import mixins from '@synergycms_core/less/mixins.js';

export default {
    promoContainer: {},
    inputPromo: {},
    dropDownContainer:{},
    animationContainer:{},
    dropDown:{},
    dropDownTop:{},
    dropDownBottom:{},
    animationContent:{},
    searchButtonContainer:{},
    searchButton:{},
    portalDesign:{},
    engineMerged:{},
    defaultStyle: data => ({
      textAlign:'left',
      [`@media (min-width: ${data.modalBreak}px)`]: {
        font: '13px ' + data.fontFamily1,
        letterSpacing: '1px',
        paddingTop:'0',
        //height:'100%'
      },
      '& > span': {
        verticalAlign: 'middle',
        [`@media (min-width: ${data.modalBreak}px)`]: {
          paddingLeft:'0'
        }
      },
      '&:lang(ar)':{
        [`@media (min-width: ${data.modalBreak}px)`]: {
          paddingLeft:'0',
          paddingRight:'0'
        }
      },
      '& $promoContainer':{
        [`@media (min-width: ${data.modalBreak}px)`]: {
          display:'flex',
          alignItems:'center',
          height:'100%',
          '& > div':{
            height:'100%',
            width:'100%'
          }
        },
        '& $dropDown': {
          zIndex: 200,
          position:'relative',
          [`@media (min-width: ${data.modalBreak}px)`]: {
            position: 'absolute',
            left: '-160px',
            right:'-80px',
            paddingTop:'0',
            overflow:'hidden',
            zIndex:201,
          },
          '& $dropDownContainer':{
            [`@media (min-width: ${data.modalBreak}px)`]: {
                padding:'10px 5px',
            },
            '& $animationContainer':{
              [`@media (min-width: ${data.modalBreak}px)`]: {
                '&:before': {
                  left: '50%',
                  marginLeft: '30px',
                  marginBottom: 0,
                  borderBottom: '6px solid #fff',
                  borderLeft: '6px solid transparent',
                  borderRight: '6px solid transparent',
                  content: `''`,
                  position: 'absolute',
                  top:'4px'
                },
                '&:lang(ar)': {
                  '&:before':{
                    left: '61.5%'
                  }
                }
              },
              '& $animationContent':{
                [`@media (min-width: ${data.modalBreak}px)`]: {
                  boxShadow: '0 3px 4px 0 rgba(0,0,0,.3)',
                  position:'relative',
                  backgroundColor:'#fff',
                  padding:'15px 10px',
                  ...mixins.boxSizing()
                },
                '& $inputPromo': {
                  font: data => '300 13px ' + data.fontFamily1,
                  ...mixins.boxSizing(),
                  color: '#000',
                  height: '40px',
                  width: '100%',
                  border: '1px solid #ddd',
                  padding: '0 44px 0 44px',
                  backgroundColor:'#fff',
                  '&:lang(ar)':{
                    textAlign: 'right',
                  },
                  [`@media (min-width: ${data.modalBreak}px)`]: {
                    fontSize: '13px',
                    background: 'transparent',
                    display:'inline-block',
                    verticalAlign:'middle',
                    width:'calc(100% - 120px)',
                    padding:'0 10px'
                  },
                },
                '& $searchButtonContainer':{
                  [`@media (min-width: ${data.modalBreak}px)`]: {
                    paddingLeft:'10px',
                    display:'inline-block',
                    verticalAlign:'middle',
                    width:'110px',
                    '&:lang(ar)':{
                      paddingLeft: '0',
                      paddingRight: '10px',
                    }
                  },
                  '& $searchButton':{
                    [`@media (max-width: ${data.modalBreak - 1}px)`]: {
                      position: 'fixed',
                      left: 0,
                      right: 0,
                      width: '100%',
                      bottom: '0',
                      zIndex:2,
                      font: 'italic 16px ' + data.fontFamily2,
                    },
                    [`@media (min-width: ${data.modalBreak}px)`]: {
                      height:'40px',
                      padding:'0 5px',
                      textTransform:'uppercase'
                    }
                  },
                },
              },
            },
          }
        },
        '& $dropDownTop': {
          '@media (min-width: 801px)': {
            bottom: 'calc(100% + 2px)',
          },
          '& $dropDownContainer':{
            '& $animationContainer':{
              '@media (min-width: 801px)': {
                '&:before': {
                  bottom:'4px',
                  transform: 'rotate(180deg)'
                },
              },
            },
          }
        },
        '& $dropDownBottom': {
          '@media (min-width: 801px)': {
            top: 'calc(100% + 2px)',
          },
          '& $dropDownContainer':{
            '& $animationContainer':{
              '@media (min-width: 801px)': {
                '&:before': {
                  top:'4px'
                },
              },
            },
          }
        },
      },
      '&$portalDesign':{
        '& $promoContainer':{
          '& $dropDown': {
            '& $dropDownContainer':{
              [`@media (min-width: ${data.modalBreak}px)`]: {
                padding:'10px 9px'
              },
              '& $animationContainer':{
                '&:before':{
                  top:'-6px',
                  left: '60%'
                },
                '&:lang(ar)':{
                  '&:before':{
                    left: '67%',
                  }
                },
                [`@media (min-width: ${data.modalBreak}px)`]: {
                  filter:'drop-shadow(0px 2px 5px rgba(0,0,0,50%))'
                },
                '& $animationContent':{
                  [`@media (min-width: ${data.modalBreak}px)`]: {
                    boxShadow:'none',
                  },
                  '& $searchButtonContainer':{
                    '& $searchButton':{
                      [`@media (max-width: ${data.modalBreak - 1}px)`]: {
                        position: 'fixed',
                        left: 0,
                        right: 0,
                        width: '100%',
                        bottom: '0',
                        zIndex:2,
                        font: 'italic 16px ' + data.fontFamily2,
                      },
                      [`@media (min-width: ${data.modalBreak}px)`]: {
                        height:'40px',
                        padding:'0 5px',
                        textTransform:'uppercase'
                      }
                    },
                  },
                },
              },
            },
          },
          '& $dropDownTop': {
            '& $dropDownContainer':{
              '& $animationContainer':{
                '&:before':{
                  bottom:'-6px',
                },
              },
            }
          },
          '& $dropDownBottom': {
            '& $dropDownContainer':{
              '& $animationContainer':{
                '&:before':{
                  top:'-6px',
                },
              },
            }
          },
        }
        
      },
      '&$engineMerged':{
        '& $promoContainer':{
          [`@media (min-width: ${data.modalBreak}px)`]: {
            '& $dropDown': {
              left: '-230px',
            }
          },
        }
      }
    }),
    iconsEngine: data => ({
      position: 'absolute',
      fontSize: '22px',
      lineHeight: '40px',
      left: '12px',
      top: 0,
      color: data.mainColor,
      [`@media (min-width: ${data.modalBreak}px)`]: {
        lineHeight: '50px'
      },
      '&:lang(ar)': {
        left: 'auto',
        right: '12px'
      }
    }),
    dropDownEnter: data => ({
      [`@media (max-width: ${data.modalBreak - 1}px)`]: {
        opacity: 0,
        transition: 'opacity 0ms ease-out',
        transitionDelay: '2s'
      },
      [`@media (min-width: ${data.modalBreak}px)`]: {
        transition: 'max-height 0ms ease-out',
        maxHeight: '0'
      }
    }),
    dropDownEnterActive: data => ({
      [`@media (max-width: ${data.modalBreak - 1}px)`]: {
          opacity: 1,
          transition: 'opacity 300ms ease-out',
          transitionDelay: '.3s'
      },
      [`@media (min-width: ${data.modalBreak}px)`]: {
          maxHeight: '100px',
          transition: 'max-height 600ms ease-out',
          overflow: 'hidden'
      }
    }),
    dropDownLeave: data => ({
      [`@media (max-width: ${data.modalBreak - 1}px)`]: {
          opacity: 1,
          transition: 'opacity 300ms ease-out'
      },
      [`@media (min-width: ${data.modalBreak}px)`]: {
          maxHeight: '100px',
          transition: 'max-height 500ms ease-out',
          overflow: 'hidden'
      }
    }),
    dropDownLeaveActive: data => ({
      [`@media (max-width: ${data.modalBreak - 1}px)`]: {
          opacity: 0,
          transition: 'opacity 300ms ease-out'
      },
      [`@media (min-width: ${data.modalBreak}px)`]: {
          transition: 'max-height 500ms ease-out',
          maxHeight: '0'
      }
    }),
    closeButtonClose: {
      color: '#fff',
      width: '30px',
      height: '40px',
      position:'absolute',
      zIndex:1,
      right:0,
      '& > span': {
        fontSize: '12px',
        lineHeight: '1px',
        color:'#b2b2b2',
      },
      '&:lang(ar)':{
        left: '0',
        right: 'auto',
      }
    },
    roundedTheme:{
      '& $promoContainer':{
        '& $dropDown':{
          '& $dropDownContainer':{
            '& $animationContainer':{
              '&:before':{
                content: 'unset'
              },
              '& $animationContent':{
                borderRadius: '15px',
                '& $inputPromo':{
                  borderRadius: '25px',
                },
                '& $searchButtonContainer':{
                  '& $searchButton':{
                    borderRadius: '25px'
                  },
                },
              },
            },
          },
        },
      }
    }
};